import { useEffect, useState } from 'react'

const QUERY = '(min-width: 1200px)'

/** Drives the structural switch between the mobile tabbed/bottom-sheet layout (Main.dc.html /
 *  MobileFilters.dc.html) and the desktop filter-rail layout (Desktop.dc.html /
 *  DesktopCards.dc.html) - a JS-level decision, not just CSS, because the filter panel renders as
 *  a different DOM structure (inline <aside> vs. a bottom-sheet overlay), not just different
 *  styling of the same markup. Same hook/breakpoint as event-page's own useIsMobile.ts. */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => (typeof window === 'undefined' ? false : !window.matchMedia(QUERY).matches))

  useEffect(() => {
    const mql = window.matchMedia(QUERY)
    const onChange = () => setIsMobile(!mql.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return isMobile
}
